/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtocreateevents3Inputs */

const en_failedtocreateevents3 = /** @type {(inputs: Failedtocreateevents3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create events`)
};

const de_failedtocreateevents3 = /** @type {(inputs: Failedtocreateevents3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events konnten nicht erstellt werden`)
};

/**
* | output |
* | --- |
* | "Failed to create events" |
*
* @param {Failedtocreateevents3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtocreateevents3 = /** @type {((inputs?: Failedtocreateevents3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtocreateevents3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtocreateevents3(inputs)
	return de_failedtocreateevents3(inputs)
});
export { failedtocreateevents3 as "failedToCreateEvents" }